<form [formGroup]="form">
  <div class="sections">
    <section>
      <mat-form-field appearance="outline">
        <mat-label>Work Center ID</mat-label>
        <input matInput formControlName="id" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Number</mat-label>
        <input matInput formControlName="number" />
      </mat-form-field>
    </section>
  </div>
  <div class="actions">
    <button mat-flat-button (click)="onCancel()">Cancel</button>
    <button color="primary" [disabled]="!form.valid" mat-flat-button (click)="onAdd()">Add</button>
  </div>
</form>
